/* HAB Collections — product page behaviour:
   size/variant selection, per-size stock urgency, gallery, delivery estimate. */
(function () {
  if (window.__habPDP) return;
  window.__habPDP = true;

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-hab-pdp]');
    if (!root) return;

    var $  = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var raw = $('[data-hab-variants]');
    var variants = [];
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }

    var idInput = $('[data-hab-variant-id]');
    var priceEl = $('[data-hab-price]');
    var availEl = $('[data-hab-avail]');
    var noteEl  = $('[data-hab-stocknote]');
    var atcBtn  = $('[data-hab-atc]');

    var chosen = {};   // option position -> value
    var sizePos = null;

    $$('[data-hab-opt]').forEach(function (b) {
      var pos = b.getAttribute('data-hab-opt');
      if (b.closest('.sizebtns') && b.parentElement.hasAttribute('data-hab-optgroup')) sizePos = pos;
      if (b.classList.contains('on')) chosen[pos] = b.getAttribute('data-hab-value');
    });

    // Whole rupees print without decimals; paise (e.g. after a % sale) print with two.
    function money(cents) {
      var digits = cents % 100 === 0 ? 0 : 2;
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: digits });
    }

    var salePct = priceEl ? parseInt(priceEl.getAttribute('data-hab-sale-pct') || '0', 10) : 0;

    function match() {
      return variants.find(function (v) {
        return Object.keys(chosen).every(function (pos) {
          return v['option' + pos] === chosen[pos];
        });
      });
    }

    function paint() {
      var v = match();
      if (!v) return;

      if (idInput) idInput.value = v.id;

      if (priceEl) {
        // Mirrors the Liquid in hab-main-product: SALE items show the price after the cart's automatic discount.
        var price = salePct ? Math.floor((v.price * (100 - salePct)) / 100) : v.price;
        var mrp = v.compare_at_price || 0;
        if (salePct && mrp < v.price) mrp = v.price;
        var html = '<span class="price">' + money(price) + '</span>';
        if (mrp > price) {
          var pct = Math.round((1 - price / mrp) * 100);
          html += '<span class="mrp">' + money(mrp) + '</span><span class="off">' + pct + '% off</span>';
        }
        priceEl.innerHTML = html;
      }

      if (availEl) {
        availEl.innerHTML = v.available
          ? '<span style="color:var(--hab-ok);font-weight:600">In stock</span>'
          : '<span style="color:var(--hab-sale)">Sold out</span>';
      }

      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? (atcBtn.dataset.label || 'Add to bag') : 'Sold out';
      }

      if (noteEl && sizePos && chosen[sizePos]) {
        var btn = $$('[data-hab-opt="' + sizePos + '"]').find(function (b) {
          return b.getAttribute('data-hab-value') === chosen[sizePos];
        });
        var qty = btn ? parseInt(btn.getAttribute('data-hab-qty') || '0', 10) : 0;
        if (!v.available) {
          noteEl.textContent = '● Sold out in ' + chosen[sizePos];
          noteEl.className = 'stocknote';
        } else if (qty > 0 && qty <= 2) {
          noteEl.textContent = '● Only ' + qty + ' left in ' + chosen[sizePos] + ' — selling fast';
          noteEl.className = 'stocknote';
        } else {
          noteEl.textContent = '● In stock in ' + chosen[sizePos];
          noteEl.className = 'stocknote ok';
        }
      }

      // keep the URL shareable / correct on refresh
      if (history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    if (atcBtn) atcBtn.dataset.label = atcBtn.textContent.trim();

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hab-opt]');
      if (!b || b.disabled) return;
      var pos = b.getAttribute('data-hab-opt');
      Array.prototype.forEach.call(b.parentElement.children, function (s) { s.classList.remove('on'); });
      b.classList.add('on');
      chosen[pos] = b.getAttribute('data-hab-value');
      paint();
    });

    /* ---- guard: don't let anyone add to cart without picking a size ---- */
    var form = document.getElementById('HabProductForm');
    if (form && sizePos) {
      form.addEventListener('submit', function (e) {
        if (!chosen[sizePos]) {
          e.preventDefault();
          e.stopPropagation();
          if (window.habToast) window.habToast('Please select a size first');
          var g = $('.sizebtns');
          if (g) {
            g.scrollIntoView({ block: 'center', behavior: 'smooth' });
            g.animate([{ opacity: 1 }, { opacity: 0.35 }, { opacity: 1 }], { duration: 600, iterations: 2 });
          }
        }
      });
    }

    var sticky = $('[data-hab-sticky-atc]');
    if (sticky && form) sticky.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });

    /* ---- gallery ---- */
    var gimg = $('[data-hab-gimg]'), thumbs = $$('[data-hab-gi]'), gi = 0;
    function setImg(i) {
      if (!thumbs.length || !gimg) return;
      gi = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, j) { t.classList.toggle('on', j === gi); });
      gimg.src = thumbs[gi].getAttribute('data-src');
      var gm = $('[data-hab-gmain]'); if (gm) gm.classList.remove('zoom');
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hab-gi]');
      if (t) { setImg(parseInt(t.getAttribute('data-hab-gi'), 10)); return; }
      var n = e.target.closest('[data-hab-gnav]');
      if (n) { setImg(gi + parseInt(n.getAttribute('data-hab-gnav'), 10)); return; }
      if (e.target.closest('[data-hab-gmain]')) $('[data-hab-gmain]').classList.toggle('zoom');
    });

    /* ---- delivery estimate ----
       Client-side estimate from your own dispatch times. Swap this for a
       courier serviceability API when you install a logistics app. */
    var METRO = ['11', '12', '11', '40', '41', '56', '60', '70', '50', '20', '38', '39', '30', '80', '10'];
    function estimateDate(days) {
      var d = new Date(Date.now() + days * 86400000);
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    }
    function renderClientEstimate(res, v) {
      var metro = METRO.indexOf(v.slice(0, 2)) !== -1;
      var days = parseInt(res.getAttribute(metro ? 'data-metro-days' : 'data-rest-days'), 10) || 5;
      res.innerHTML = '✓ Delivers to ' + v + ' by <b>' + estimateDate(days) + '</b>';
    }
    var pinBtn = $('[data-hab-pin-check]');
    if (pinBtn) {
      pinBtn.addEventListener('click', function () {
        var input = $('[data-hab-pin]'), res = $('[data-hab-pin-res]');
        var v = (input.value || '').trim();
        if (!/^\d{6}$/.test(v)) {
          res.innerHTML = '<span style="color:var(--hab-sale)">Enter a valid 6-digit pincode</span>';
          return;
        }
        var apiUrl = res.getAttribute('data-service-api');
        if (!apiUrl) { renderClientEstimate(res, v); return; }

        res.textContent = 'Checking…';
        fetch(apiUrl + '/serviceability?delivery_postcode=' + v)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data || !data.serviceable) {
              res.innerHTML = '<span style="color:var(--hab-sale)">Sorry, we don’t deliver to ' + v + ' yet</span>';
              return;
            }
            res.innerHTML = '✓ Delivers to ' + v + ' by <b>' + estimateDate(data.days) + '</b>';
          })
          .catch(function () { renderClientEstimate(res, v); });
      });
      var pinInput = $('[data-hab-pin]');
      if (pinInput) pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); pinBtn.click(); } });
    }

    paint();
  });
})();